/**
 * Point CA ↔ US switcher links at the matching hreflang URL.
 *
 * Translate & Adapt changes handles (/pages/store → /fr/pages/magasins).
 * The switcher used to strip /fr and keep the French handle, which 404s on US.
 * The hreflang-tags app already emits the correct alternate (en-us / en-ca).
 */
(() => {
  const ATTR = 'data-fv-hreflang';

  const alternateHref = (hreflang) => {
    const wanted = String(hreflang || '').toLowerCase();
    if (!wanted) return null;

    for (const link of document.querySelectorAll('link[rel="alternate"][hreflang]')) {
      const value = (link.getAttribute('hreflang') || '').toLowerCase();
      if (value === wanted && link.href) return link.href;
    }

    return null;
  };

  const apply = () => {
    document.querySelectorAll(`[${ATTR}]`).forEach((el) => {
      const href = alternateHref(el.getAttribute(ATTR));
      if (!href) return;

      if (el instanceof HTMLAnchorElement) {
        el.href = href;
      } else if (el instanceof HTMLOptionElement) {
        el.setAttribute('data-store-url', href);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
